import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-principal-becario',
  templateUrl: './principal-becario.component.html',
  styleUrls: ['./principal-becario.component.css']
})
export class PrincipalBecarioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
